import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg02.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Accelerate Your Brand With TekRevol’s Premier App Developers in
                California
              </h2>
            </div>
            <p>
              At TekRevol, we pride ourselves on being the premier destination
              for unlocking the true potential of your brand through expert app
              development in California. Our team is composed of visionary
              designers, developers, and strategists who collaboratively work to
              drive your brand’s success. That’s the reason why our professional
              app development team is the driving force behind our reputation
              for excellence in California.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
